import React from 'react';
import { AlertTriangle, Pill, UtensilsCrossed } from 'lucide-react';
export function Problem() {
  return <section className="py-20 bg-gray-50 border-y border-gray-200" data-id="element-153">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <div className="max-w-4xl mx-auto" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-156">
            El verdadero problema del hispano en USA
          </h2>

          <div className="grid md:grid-cols-2 gap-10" data-id="element-157">
            <div className="space-y-6" data-id="element-158">
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-159">
                Para el hispano que vive en USA, mantenerse sano es una batalla
                cuesta arriba. Los supermercados están llenos de{' '}
                <strong data-id="element-160">"comida muerta"</strong> cargada de jarabe de maíz y
                aceites inflamatorios que destrozan su energía.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-161">
                Ese "sopor" después del almuerzo, el dolor en las rodillas al
                levantarse y la dificultad para bajar aunque sea una libra{' '}
                <span className="font-semibold text-orange-600" data-id="element-162">
                  no son fallas de su cuerpo
                </span>
                . Son señales de que su mitocondria —su fábrica de energía— está
                ahogada.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md border border-gray-100 space-y-6" data-id="element-163">
              <div className="flex items-start gap-4" data-id="element-164">
                <div className="bg-gray-100 p-3 rounded-lg mt-1" data-id="element-165">
                  <Pill className="w-6 h-6 text-gray-600" data-id="element-166" />
                </div>
                <div data-id="element-167">
                  <h3 className="font-bold text-gray-900 text-lg mb-2" data-id="element-168">
                    El sistema médico tradicional
                  </h3>
                  <p className="text-gray-600" data-id="element-169">
                    Solo le ofrece pastillas para tapar los síntomas, sin ir a
                    la raíz del problema.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-170">
                <div className="bg-orange-100 p-3 rounded-lg mt-1" data-id="element-171">
                  <UtensilsCrossed className="w-6 h-6 text-orange-600" data-id="element-172" />
                </div>
                <div data-id="element-173">
                  <h3 className="font-bold text-gray-900 text-lg mb-2" data-id="element-174">
                    Nadie le enseña cómo comer
                  </h3>
                  <p className="text-gray-600" data-id="element-175">
                    Nadie le dice cómo comer su arroz, sus frijoles y su sazón
                    de forma que le den vida en lugar de quitársela.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}